const PROTOCOL = 'cubic';

/**
 * Builds the `cubic://` link that opens an internal path, e.g. `/pr/o/r/pull/1`, in the desktop app.
 * Internal-path links the web app emits go through `buildDesktopAppLink`, which only builds links
 * the desktop app can open.
 */
export function buildDeepLink(path: string): string {
  return `${PROTOCOL}://${path.replace(/^\/+/, '')}`;
}

/**
 * Converts a `cubic://` deep link into the web app path it points at, keeping its query and hash.
 * `cubic://pr/owner/repo/pull/1` parses with `pr` as the URL host, so the host is the first
 * path segment. Returns `null` for other schemes and for links that carry credentials.
 */
export function getDeepLinkPath(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  if (parsed.protocol !== `${PROTOCOL}:` || parsed.username || parsed.password) {
    return null;
  }

  const path = parsed.host ? `/${parsed.host}${parsed.pathname}` : parsed.pathname;
  return `${path}${parsed.search}${parsed.hash}`;
}
